import React, {useState} from 'react'
import {Button, Descriptions, Form, Input, message, Modal, Select, Space, Table} from "antd";
import {getStockDetails} from "../../../services/serviceOffer";
import {getStockInformation} from "../../../services/serviceInventory";
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import config from "../../../config";


const OfferUpdateInfo = ({rowCount, record}) => {
    const [form] = Form.useForm()
    const [modalStatus, setModalStatus] = useState(false)
    const [history, setHistory] = useState([])
    const [stockInfo, setStockInfo] = useState([])
    const [filteredHistory, setFilteredHistory] = useState([])


    async function handleInfoClick() {
        if (!record.stock){
            message.warning('Lütfen Önce Stok Seçiniz')
            return
        }
        let stockId = Number(record.stock.id)
        let hasInfo = false
        let hasHistory = false

        await getStockInformation(stockId)
            .then(({data}) => {
                if (data.length) {
                    const stockInfos = data.map(item => {
                        return {
                            quantity: `${item.quantity} ${item.stock.unit}`,
                            warehouse: `${item.warehouse.code} - ${item.warehouse.name}`,
                        }
                    })
                    hasInfo = true
                    setStockInfo(stockInfos)
                }
            })

        await getStockDetails(stockId)
            .then(({data}) => {
                if (data.length) {
                    let filtered = []
                    data.forEach(item => {
                        let obj = {
                            key: item.bidNumber,
                            ...item
                        }
                        filtered.push(obj)
                    })
                    hasHistory = true
                    setHistory(filtered)
                }
            })

        if (hasHistory || hasInfo) {
            changeModalStatus()
            return
        }

        message.warning('Stok ile ilgili Bilgi Bulunamadı')
    }


    const columns = [
        {
            title: 'Teklif Numarası',
            dataIndex: 'bidNumber',
            key: 'bidNumber'
        },
        {
            title: 'Müşteri',
            dataIndex: 'customerName',
            key: 'customerName'
        },
        {
          title: 'Tarih',
          dataIndex: 'createdDate',
          render: (t) => userDateFormatter(t)
        },
        {
            title: 'Kur',
            dataIndex: 'currency',
            key: 'currency'
        },
        {
            title: 'Miktar',
            dataIndex: 'amount',
            key: 'amount'
        },
        {
            title: 'Birim Fiyat',
            dataIndex: 'price',
            key: 'price',
            render: (t) => t.toFixed(3)
        },
        {
            title: 'İskonto %',
            dataIndex: 'discount',
            render: (t, r) => r.discount > 0 ? r.discount : '-'
        },
        {
            title: 'İskonto Hariç Toplam',
            render: (t, r) => (r.amount * r.price).toFixed(2)
        },
        {
            title: 'Teklif Satır Toplamı',
            render: (t, r) => r.discount > 0
                ? calcPriceWithDiscount((r.amount * r.price), r.discount).toFixed(2)
                : (r.amount * r.price).toFixed(2)
        },
        {
            title: 'Teklif Durumu',
            render: (t, r) => r.bidStatus === 'WAITING' ? 'Bekliyor' : r.bidStatus === 'NEGATIVE' ? 'Olumsuz' : 'Olumlu'
        }
    ]
    const changeModalStatus = () => setModalStatus(!modalStatus)
    const calcPriceWithDiscount = (basePrice, discount) => basePrice - ((basePrice * discount) / 100)

    const handleCustomerFilter = (val) => {
        if (val) {
            const filterStr = form.getFieldValue('customerNameInput')
            const status = form.getFieldValue('bidStatus')

            if (filterStr && !status) {
                const filteredData = history.filter(({customerName}) => customerName.toLocaleLowerCase().includes(filterStr.toLocaleLowerCase()))

                if (filteredData.length) {
                    setFilteredHistory(filteredData)

                    return;
                }
            }

            if (!filterStr && status) {
                const filteredData = history.filter(({bidStatus}) => bidStatus === status)

                if (filteredData.length) {
                    setFilteredHistory(filteredData)

                    return;
                }
            }

            if (filterStr && status) {
                const filteredData = history.filter(({customerName, bidStatus}) => {
                    return customerName.toLocaleLowerCase().includes(filterStr.toLocaleLowerCase()) && bidStatus === status
                })

                if (filteredData.length) {
                    setFilteredHistory(filteredData)

                    return;
                }
            }
        }

        setFilteredHistory([])
    }

    const handleFilterClear = () => {
        form.setFieldsValue({customerNameInput: '', bidStatus: ''})
        setFilteredHistory([])
    }


    return (
        <React.Fragment>
            <Form>
                <Form.Item>
                    <Button
                        type={"link"}
                        onClick={handleInfoClick}
                        style={{border: '1px solid #1dafe3', borderRadius: '8px'}}
                    >
                        {rowCount}
                    </Button>
                </Form.Item>
            </Form>

            <Modal
                open={modalStatus}
                title={'Stok Bilgisi'}
                closable={false}
                style={{minWidth: '75%'}}
                footer={[
                    <Button
                        key={'CancelButton'}
                        onClick={changeModalStatus}
                    >
                        Kapat
                    </Button>
                ]}
            >
                {
                    history.length
                        ? <div>
                            <Space direction={'vertical'} style={{width: '100%'}}>
                                <h4>Stok Geçmişi</h4>
                                <Form layout={'inline'} form={form}>
                                    <Form.Item name={'customerNameInput'}>
                                        <Input placeholder={'Müşteri Adı'}/>
                                    </Form.Item>
                                    <Form.Item style={{minWidth: '175px'}} name={'bidStatus'}>
                                        <Select placeholder={'Teklif Durumu'} options={config.bidStatus.map(i => ({label: i.text, value: i.key}))}></Select>
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type={'primary'} onClick={handleCustomerFilter}>Ara</Button>
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type={'link'} danger onClick={handleFilterClear}>Temizle</Button>
                                    </Form.Item>
                                </Form>
                                <Table scroll={{x: 'max-content'}}
                                       columns={columns}
                                       dataSource={filteredHistory.length ? filteredHistory : history}
                                       onRow={() => {
                                           return {
                                               onMouseDown: (e) => e.preventDefault()
                                           }
                                       }}
                                />
                            </Space>
                        </div>
                        : null
                }
                {
                    stockInfo.length ?
                        <div>
                            <h4>Depo - Stok Sayısı</h4>
                            <Descriptions bordered>
                                {
                                    stockInfo.map((item, index) => {
                                        return(
                                            <Descriptions.Item key={index} label={item.warehouse}>{item.quantity}</Descriptions.Item>
                                        )
                                    })
                                }
                            </Descriptions>
                        </div> : null
                }
            </Modal>
        </React.Fragment>
    )
}
export default OfferUpdateInfo